module.exports = __webpack_public_path__ + "static/img/6-dell.5ace155d.png";